import {useCallback, useState} from "react";

export const useModal = () => {

    const [modalState, setModalState] = useState({
        isOpen: false,
        selectedItem: null,
        mode: 'null'
    });
    const closeModal = useCallback(() => {
        setModalState({
            isOpen: false,
            mode: null,
            selectedItem: null
        })
    }, [])

    const openModal = useCallback((mode, item = null) => {
        console.log("MODE :",mode)
        setModalState({
            isOpen: true,
            mode: mode,
            selectedItem: item
        })
    }, [])

    return {modalState, openModal, closeModal}

}